module.exports = __webpack_public_path__ + "media/components/subscribepage/static/close-8957689e4ec347ef675d6e221670ba25.svg";